import {AnimationBaseController, IAnimationControllerConfiguration, Inject, GameRandom} from "@denishussar/html5-game-engine";
import {RootHtml} from "@denishussar/html5-game-engine";
import {GameLogic} from "./Logic/GameLogic";
import {GameModel} from "./Models/GameModel";
import { CameraConstants } from "./Constants/CameraConstants";
import { FieldTypeConstants } from "./Constants/FieldTypeConstants";
import {MiniMapController} from "./Controllers/MiniMap/MiniMapController";

export interface IGameControllerOptions
{
}

export class GameController extends AnimationBaseController {
    $model: GameModel;
    private _screenWidth: number;
    private _screenHeight: number;

    public constructor(@Inject private _options:IGameControllerOptions,
                       @Inject private _rootHtml: RootHtml,
                       @Inject private _random: GameRandom,
                       @Inject private _gameLogic: GameLogic) {
        super("GameController");
        console.log('GameController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            childControllers: {

            },
            modelWatch: {
                cameraIndex: (cameraIndex: CameraConstants) =>{
                    this.gotoAndStopByQuery('field_medium', this._getFrameByCameraIndex(cameraIndex));
                    this.gotoAndStop(this._getFrameByCameraIndex(cameraIndex));
                },
                fieldType: () => {
                    this._onChangeFieldType();
                }
            },
        };
    }

    protected async onInitialize() {
        this.gotoAndStop(this._getFrameByCameraIndex(this.$model.cameraIndex));
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onResize(width: number, height: number, scale: number): void {
        this._screenWidth = width/scale;
        this._screenHeight = height/scale;
    }

    protected onUpdate(frameRate: number): void {
    }

    private _onChangeFieldType() {
        let cameraIndex = CameraConstants.MediumAway;
        switch (this.$model.fieldType) {
            case FieldTypeConstants.Small:
                cameraIndex = CameraConstants.SmallAway;
            break;
            case FieldTypeConstants.Medium:
                cameraIndex = CameraConstants.MediumAway;
            break;
            case FieldTypeConstants.Big:
                cameraIndex = CameraConstants.BigAway;
            break;
        }
        console.log('_onChangeFieldType', cameraIndex);

        this._gameLogic.setCamera(cameraIndex);
    }

    private _getFrameByCameraIndex(cameraIndex: CameraConstants) {
        let cameraMap = {
            [CameraConstants.BigAway]: 0,
            [CameraConstants.BigClose]: 1,
            [CameraConstants.BigBack]: 0,
            [CameraConstants.MediumAway]: 0,
            [CameraConstants.MediumClose]: 1,
            [CameraConstants.MediumBack]: 2,
            [CameraConstants.SmallAway]: 4,
            [CameraConstants.SmallClose]: 5,
            [CameraConstants.SmallBack]: 4,

            [CameraConstants.MediumAwayB]: 2,
        };

        return cameraMap[cameraIndex];
    }
}

